(function () {
  function boot() {
    const drawer = document.getElementById('wt-drawer-nav');
    const header = document.querySelector('page-header.wt-header');
    const menu = drawer && drawer.querySelector('[data-alt-visual-menu]');
    if (!drawer || !header || !menu || menu.dataset.altairMenuReady) return;
    menu.dataset.altairMenuReady = 'true';
    const title = drawer.querySelector('[data-alt-menu-title]');
    const back = drawer.querySelector('[data-alt-menu-back]');
    const products = drawer.querySelector('[data-alt-menu-products]');
    const mobileTabs = drawer.querySelectorAll('[data-alt-mobile-tab]');
    const categoryTabs = drawer.querySelectorAll('[data-alt-menu-tab]');
    const categoryGroups = drawer.querySelectorAll('[data-alt-menu-group]');
    const moreButton = drawer.querySelector('[data-alt-menu-more-toggle]');
    const moreItems = drawer.querySelectorAll('[data-alt-menu-more-item]');
    const headerTabs = header.querySelectorAll('[data-alt-header-tab]');
    const desktopMenuTrigger = header.querySelector('.wt-header__menu-trigger');
    const home = drawer.querySelector('[data-alt-menu-home]');
    const catalog = drawer.querySelector('[data-alt-menu-catalog]');
    let activeCategory = 'suitcases';
    function setCategory(category) {
      activeCategory = category === 'accessories' ? 'accessories' : 'suitcases';
      menu.dataset.menuCategory = activeCategory;
      categoryTabs.forEach(function (tab) {
        const selected = tab.dataset.altMenuTab === activeCategory;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      categoryGroups.forEach(function (group) { group.hidden = group.dataset.altMenuGroup !== activeCategory; });
      if (menu.dataset.menuView === 'products') title.textContent = activeCategory === 'accessories' ? (categoryTabs[1]?.textContent.trim() || 'ACCESSOIRES') : (categoryTabs[0]?.textContent.trim() || 'KOFFER');
    }
    function setView(view) {
      menu.dataset.menuView = view;
      mobileTabs.forEach(function (tab) { tab.setAttribute('aria-expanded', view === 'products' && tab.dataset.altMobileTab === activeCategory ? 'true' : 'false'); });
      back.hidden = view !== 'products';
      title.textContent = view === 'products' ? (activeCategory === 'accessories' ? categoryTabs[1].textContent.trim() : categoryTabs[0].textContent.trim()) : (menu.dataset.menuHomeTitle || 'ALTAIR');
      home.setAttribute('aria-hidden', view === 'products' ? 'true' : 'false');
      catalog.setAttribute('aria-hidden', view === 'products' || innerWidth >= 1200 ? 'false' : 'true');
      drawer.querySelector('.wt-drawer__content').scrollTop = 0;
    }
    function placeDesktopPanel() {
      if (innerWidth < 1200) {
        drawer.style.removeProperty('--altair-menu-top');
        return;
      }
      drawer.style.setProperty('--altair-menu-top', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
    }
    mobileTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setCategory(tab.dataset.altMobileTab);
        if (innerWidth >= 1200) menu.dataset.menuMode = 'catalog';
        setView('products');
        if (innerWidth < 1200) back.focus();
      });
    });
    categoryTabs.forEach(function (tab) { tab.addEventListener('click', function () { setCategory(tab.dataset.altMenuTab); }); });
    if (moreButton) moreButton.addEventListener('click', function () {
      const expanded = moreButton.getAttribute('aria-expanded') !== 'true';
      moreItems.forEach(function (item) { item.hidden = !expanded; });
      moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      moreButton.textContent = (expanded ? moreButton.dataset.collapseLabel + ' ↑' : moreButton.dataset.expandLabel + ' ↓');
    });
    headerTabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        const category = tab.dataset.altHeaderTab;
        menu.dataset.menuMode = 'catalog';
        if (document.body.classList.contains('menu-open') && category !== activeCategory) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setCategory(category);
          return;
        }
        setCategory(category);
      }, true);
    });
    if (desktopMenuTrigger) desktopMenuTrigger.addEventListener('click', function (event) {
      if (innerWidth < 1200) return;
      if (document.body.classList.contains('menu-open') && menu.dataset.menuMode !== 'all') {
          event.preventDefault();
          event.stopImmediatePropagation();
          menu.dataset.menuMode = 'all';
          setView('home');
          return;
        }
        menu.dataset.menuMode = 'all';
        setView('home');
      }, true);
    back.addEventListener('click', function () { setView('home'); products.focus(); });
    const observer = new MutationObserver(function () {
      placeDesktopPanel();
      if (!document.body.classList.contains('menu-open')) setView('home');
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () { placeDesktopPanel(); if (innerWidth >= 1200) setView('home'); }, { passive: true });
    placeDesktopPanel();
    menu.dataset.menuMode = 'catalog';
    setCategory('suitcases');
    setView('home');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
